var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwsec2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F68536;}\r\n\t.st1{fill:#9D5025;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,59.6l-4.8,1.1V29.3l4.8,1.1V59.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.2,61.4l-6,1.7V26.9l6,1.7V61.4 M65,63.3l-7.7,2.8V23.9l7.7,2.8V63.3 M85.7,59.6L65,70V20l20.7,10.4V59.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.9,22.1L65,20v50l-4.1-2.1V22.1 M54.1,25.5l3.2-1.6v42.3l-3.2-1.6V25.5 M48.7,28.2l2.5-1.3v36.2l-2.5-1.3 V28.2 M46.4,29.3l-2.1,1v29.3l2.1,1V29.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsec2);
export default __webpack_public_path__ + "static/media/AWSEC2.8a6b71f3de1b0c7225bc40c5e3c629df.svg";
export { ForwardRef as ReactComponent };